import * as tslib_1 from "tslib";
import { Component, Inject } from "vue-property-decorator";
import { H3RadioList, H3CheckboxList } from "h3-mobile-vue";
import { DropdownControl } from "../control/dropdown-control";
import ControlBack from "@cloudpivot/form/src/common/directives/control-back";
let Dropdown = class Dropdown extends DropdownControl {
    constructor() {
        super(...arguments);
        this.showModal = false;
    }
    show() {
        this.showModal = true;
        this.getOPt();
    }
    close() {
        this.showModal = false;
    }
    //上下布局模式
    get layoutType() {
        if (this.layoutTypeFn) {
            return this.layoutTypeFn();
        }
    }
    onChange(val) {
        if (val) {
            this.ctrl.value = this.multiple ? val.slice() : val.value;
        }
        else {
            this.ctrl.value = null;
        }
    }
    handleValueChange(value) {
        if (Array.isArray(value)) {
            value = value.filter(x => !!x);
        }
        super.handleValueChange(value);
    }
    getOPt() {
        super.getOptions();
    }
    clearOption(change) {
        this.options = [];
        this.ctrl.value = null;
    }
};
tslib_1.__decorate([
    Inject()
], Dropdown.prototype, "layoutTypeFn", void 0);
Dropdown = tslib_1.__decorate([
    Component({
        name: "dropdown",
        components: {
            H3RadioList,
            H3CheckboxList
        },
        directives: {
            ControlBack
        },
        mixins: []
    })
], Dropdown);
export default Dropdown;
